/* eslint-disable prettier/prettier */
import { MyThunkResult } from 'store';

import { Group } from 'models/group';
import { Response } from 'models/response';

import { doLoadGroupList, doCreateGroup, doUpdateGroupCode, doLoadGroupRequest } from '../action-creators/group';
import { profile, axiosConfig } from '../api';

interface GroupResponse {
  data: Group[];
}

export const fetchGroupList = (): MyThunkResult<Promise<void>> => (dispatch) =>
  profile.get<GroupResponse>('/UserGroup/GetAll', axiosConfig).then((response) => {
    dispatch(doLoadGroupRequest);
    const { data } = response.data;
    dispatch(doLoadGroupList(data as Group[]));
  });

export const fetchAllGroupListActive = (): MyThunkResult<Promise<void>> => (dispatch) =>
  profile.get<GroupResponse>('/UserGroup/GetAllUsersActive', axiosConfig).then((response) => {
    dispatch(doLoadGroupRequest);
    const { data } = response.data;
    dispatch(doLoadGroupList(data as Group[]));
  });

export const saveGroup =
  (group: Group): MyThunkResult<Promise<void>> =>
  (dispatch) => {
    if (group.id) {
      return profile
        .put(`/usergroup/${group.id}`, {
          ...group,
        })
        .then((response) => {
          dispatch(doUpdateGroupCode(response.data.data));
        });
    }
    return profile
      .post('/usergroup', {
        ...group,
      })
      .then((response) => {
        dispatch(doCreateGroup(response.data.data));
      });
  };

export const fetchGroup = async (groupId: string) => profile.get<Response<Group>>(`/UserGroup/${groupId}`, axiosConfig);

export const fetchGroupListService = async () => profile.get<Response<Group[]>>('/UserGroup/GetAll', axiosConfig);

export const fetchGroupListServiceByCompany = async (companyId: string) => profile.get<Response<Group[]>>(`/UserGroup/GetAllByCompany/${companyId}`, axiosConfig);
